export default {
  stepPrepare: "準備付款",
  stepProcess: "處理付款",
  stepConfirm: "確認訂單",
  preparing: "正在準備付款環境",
  confirmingPayment: "正在確認付款",
  confirmingOrder: "正在確認訂單",
  possibleIssue: "檢測到可能的問題",
  settingUp: "正在設置安全付款…",
  waitingConfirmation: "等待交易確認…",
  updatingAccount: "正在更新您的帳戶資訊…",
  paymentSuccessful: "付款成功！",
  upgradeSuccess: "您的方案已成功升級。",
  continue: "繼續",
  somethingWentWrong: "您的付款出現問題。",
  tryAgain: "重試",
  paymentCancelled: "付款已取消",
  cancelledTransaction: "您已關閉付款視窗或取消了交易。",
  timeoutMessage:
    "可能出現了問題。您可以檢查您的權益是否已生效。如需幫助，請聯絡我們的支援團隊 {supportEmail}。",
  secureEncrypted: "您的銀行資料已安全加密",
  havingTrouble: "遇到問題？聯絡 {supportEmail}",
};
